// ChatbotFAB.jsx
import styled, { keyframes } from "styled-components";
import { Sparkles } from "lucide-react";
import { useLocation } from "react-router-dom";
import { useGlobalChat } from "../../context/GlobalChatContext";

const pulse = keyframes`
  0% { box-shadow: 0 0 0 0 rgba(99,102,241,0.6); }
  70% { box-shadow: 0 0 0 16px rgba(99,102,241,0); }
  100% { box-shadow: 0 0 0 0 rgba(99,102,241,0); }
`;

const FabWrapper = styled.button`
  position: fixed;
  bottom: 24px;
  right: 24px;

  display: flex;
  align-items: center;
  gap: 12px;

  padding: 12px 14px 12px 12px;
  border-radius: 22px;

  background:
    linear-gradient(180deg, rgba(15, 23, 42, 0.94), rgba(2, 6, 23, 0.92)),
    linear-gradient(135deg, rgba(245, 158, 11, 0.18), rgba(56, 189, 248, 0.16));
  color: white;
  border: 1px solid rgba(148, 163, 184, 0.18);

  cursor: pointer;
  z-index: 999;

  animation: ${pulse} 2.5s infinite;
  box-shadow: 0 20px 44px rgba(2, 6, 23, 0.4);

  transition: all 0.25s ease;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(56, 189, 248, 0.28);
    box-shadow: 0 24px 56px rgba(2, 6, 23, 0.48);
  }

  @media (max-width: 640px) {
    padding: 12px;
    border-radius: 18px;
  }
`;

const Icon = styled.div`
  width: 42px;
  height: 42px;
  border-radius: 16px;

  background: linear-gradient(135deg, #f59e0b, #38bdf8);

  display: flex;
  align-items: center;
  justify-content: center;

  color: #04111f;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.24);
`;

const LabelWrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  min-width: 0;

  @media (max-width: 640px) {
    display: none;
  }
`;

const Kicker = styled.div`
  font-size: 10px;
  font-weight: 900;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  color: #7dd3fc;
`;

const Label = styled.div`
  margin-top: 2px;
  font-weight: 900;
  font-size: 14px;
  white-space: nowrap;
  color: #f8fafc;
`;

const Hint = styled.div`
  margin-top: 2px;
  font-size: 12px;
  color: #94a3b8;
  white-space: nowrap;

  @media (max-width: 920px) {
    display: none;
  }
`;

export default function ChatbotFAB() {
  const { openChat } = useGlobalChat();
  const location = useLocation();

  const isProductContext =
    location.pathname.startsWith("/my-product-roadmap") ||
    location.pathname.startsWith("/create-product-roadmap") ||
    location.pathname.startsWith("/product-roadmap/") ||
    location.pathname.startsWith("/product-dashboard") ||
    location.pathname.startsWith("/product-tasks-board");

  const kicker = isProductContext ? "Product AI" : "Learning AI";
  const label = isProductContext
    ? "Daily Development Assistant"
    : "Roadmap Assistant";
  const hint = isProductContext
    ? "Ask how to build today"
    : "Ask what to learn next";

  return (
    <FabWrapper
      onClick={() =>
        openChat({
          assistantMode: isProductContext ? "product-development" : "roadmap",
        })
      }
    >
      <Icon>
        <Sparkles size={18} />
      </Icon>
      <LabelWrap>
        <Kicker>{kicker}</Kicker>
        <Label>{label}</Label>
        <Hint>{hint}</Hint>
      </LabelWrap>
    </FabWrapper>
  );
}
